<div class="d-flex align-items-center">
  <h3 class="m-0 font-weight-bold">{{ title() | titlecase }}</h3>
  <button mat-icon-button color="accent" type="button" class="ml-2" [disabled]="!canModify()" (click)="addParameters.emit(formArray())">
    <mat-icon>plus_one</mat-icon>
  </button>
</div>

@for (parametersFormGroup of formArray().controls; track parametersFormGroup; let i = $index) {
<form class="pl-2 d-flex justify-content-between align-items-center w-100" [formGroup]="parametersFormGroup">
  <div class="w-25">
    <app-voucher-atp-inputs
      type="parametersLabel"
      [label]="'VOUCHER.ATP.NAME' | translate"
      [formControlName]="'name'"
      [canModify]="canModify()"
    ></app-voucher-atp-inputs>
  </div>
  <div class="px-2 pb-3">=></div>
  <div class="flex-grow-1">
    <app-voucher-atp-inputs
      [type]="type()"
      [label]="'VOUCHER.ATP.VALUE' | translate"
      [formControlName]="'value'"
      [canModify]="canModify()"
    ></app-voucher-atp-inputs>
  </div>

  <div class="px-2 pb-3">
    <button mat-icon-button type="button" color="warn" [disabled]="!canModify()" (click)="formArray().removeAt(i)">
      <mat-icon>delete</mat-icon>
    </button>
  </div>
</form>
} @if (!formArray().controls.length) {
<div class="input-min-height w-100 d-flex justify-content-center align-items-center">Invalid {{ type() }}</div>

}
